import { useState, useEffect, useContext } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Redirect } from 'react-router-dom';
import { Msg, Button } from 'react-weui';
import PropTypes from 'prop-types';
import { formatDate, formatNumber } from 'lib/formatter.ts';
import User from 'services/user2';
import TopNav from 'components/topNav.js';
import * as MobileActions from 'actions/index.ts';
import CompanyService from 'services/company2';
//审批流状态
import WorkflowStatus from 'components/workflowStatus.jsx';
//审批流按钮
import WorkflowButtons from 'components/workflowButtons.jsx';
import Util from 'lib/util.js';
import useDetail from 'hooks/useDetail';
import { ActionContext } from 'actions/context';
import Modal from 'components/modal';
import CommonFns from 'functions/common.ts';
import Download from 'components/download.js';
import Big from 'big.js';
import PaymentService from 'services/payment';

function PaymentApplyDetail(props) {
  const Config = {
    purchase: {
      title: '付款申请单详情',
      apiPath: '/paymentApply/getDetail',
      confirmApiPath: '/paymentApply/confirm',
      customerNameKey: 'companyName',
      companyCodeKey: 'companyCode',
      vendorNameKey: 'innerVendorName',
      arrEnumField: [
        {
          mainKey: 'B02_Pay_Apply_status',
          subKey: 'status',
          value: 'statusName'
        }
      ],
      idField: 'pmaXkNo',
      wfmCode: '1024'
    },
    sale: {
      title: '付款申请单详情',
      apiPath: '/customerPaymentApply/getDetail',
      customerNameKey: 'companyName',
      companyCodeKey: 'companyCode',
      vendorNameKey: 'customerName',
      arrEnumField: [
        {
          mainKey: 'B02_Pay_Apply_status',
          subKey: 'status',
          value: 'statusName'
        }
      ],
      idField: 'pmaXkNo'
    }
  };

  const SourceTypeData = [
    {
      id: 1,
      text: '对账单'
    },
    {
      id: 2,
      text: '发票单'
    },
    {
      id: 3,
      text: '付款申请'
    },
    {
      id: 4,
      text: '提前付款申请'
    },
    {
      id: 5,
      text: '预付款单'
    }
  ];

  const config = Config[props.type];

  const {
    companyCode,
    inited,
    error,
    updateTs,
    redirect,
    decimalPlace,
    fileList,
    moreSign1,
    handleMore,
    setShowLoading,
    setFileList,
    detail,
    setDetail,
    workflow,
    forceUpdate,
    self
  } = useDetail(props, config);

  const { state, dispatch } = useContext(ActionContext);
  const [boxState, setBoxState] = useState({
    1: true
  });
  const [list, setList] = useState([]);
  const [isDownErp, setIsDownErp] = useState(); //是否开启发票下行 0:不启用 1:启用  默认为0

  //处理详情数据
  self.afterGetDetail = function (data) {
    //采购方公司名
    data.companyName = self.companyInfo.companyName;

    //采购员
    data.arrSelectedBuyer = Util.jsonDecode(data.buyerCodes) || [];
    data.arrSelectedBuyerShow = data.arrSelectedBuyer
      .map(item => item.text)
      .join(', ');
    data.arrSelectedBuyerCode = data.arrSelectedBuyer.map(item => item.id);

    let Ccode = self.isPurchase ? companyCode : data.customerCode;
    CompanyService.getCompanyParamsByCodes(Ccode, [
      'Use_invoice_order_down_erp'
    ]).then(rs => {
      if (Array.isArray(rs) && rs.length) {
        let downErpFlag = rs[0].paramValue === '1' && rs[0].paramFilter === '1';
        setIsDownErp(downErpFlag);
      }
    });

    getApplyAmounts(data);
    setDetail(data);
  };

  //初始化默认企业
  useEffect(() => {
    const { match } = props;
    let routeCompanyCode = match.params.companyCode;
    self.init(routeCompanyCode);
    //卸载时
    return function unmount() {
      if (self.toastTimer) {
        clearTimeout(self.toastTimer);
      }
      if (self.loadingTimer) {
        clearTimeout(self.loadingTimer);
      }
      if (self.errorTimer) {
        clearTimeout(self.errorTimer);
      }
    };
  }, [self, props]);

  //根据依赖多次执行
  useEffect(() => {
    self.getDetail();
  }, [companyCode, self]);

  function handleBoxState(idx) {
    boxState[idx] = !boxState[idx];
    setBoxState(boxState);
    forceUpdate();
  }

  // 确认付款申请
  function confirmPaymentApply() {
    let postbody = getPostbody(config.confirmApiPath);
    PaymentService.confirmPaymentApply(
      postbody,
      () => {
        self.getDetail();
      },
      dispatch
    );
  }

  //计算申请单合计
  function getApplyAmounts(data) {
    let taxAmount = Big(0);
    let amount = Big(0);
    let should = Big(0);
    let apply = Big(0);
    let schedule = Big(0);
    data.lineList.forEach(item => {
      taxAmount = taxAmount.plus(item.sourceOrderTaxAmount || 0);
      amount = amount.plus(item.sourceOrderAmount || 0);
      should = should.plus(item.shouldReceiptTaxAmount || 0);
      apply = apply.plus(item.applyTaxAmount || 0);
      schedule = schedule.plus(item.schedulePaymentTaxAmount || 0);
    });

    data.taxAmount = taxAmount.valueOf();
    data.amount = amount.valueOf();
    data.tax = taxAmount.minus(amount).valueOf();
    data.should = should.valueOf();
    data.apply = apply.valueOf();
    data.schedule = schedule.valueOf();
  }

  //获取提交参数
  function getPostbody(apiPath) {
    let postbody = {
      pmaXkNo: self.id,
      companyCode: companyCode,
      apiPath: apiPath
    };
    return postbody;
  }

  //显示错误
  if (error !== null) {
    return <Msg {...error} />;
  }

  if (redirect !== null) {
    return <Redirect to={redirect} />;
  }

  return (
    <div>
      <TopNav inited={inited} />
      <div className="m-details-container">
        <div className="m-details-item">
          <div className="details-item-title">
            <label>基础信息</label>
          </div>
          <div className="details-item-content">
            <div className="content-line">
              <ul className="field-list">
                {self.isPurchase && (
                  <li>
                    <span className="field-label">采购方</span>
                    <div className="field-value">{detail.companyName}</div>
                  </li>
                )}
                {!self.isPurchase && (
                  <li>
                    <span className="field-label">客户名称</span>
                    <div className="field-value">
                      {detail[config.vendorNameKey]}
                    </div>
                  </li>
                )}
                <li>
                  <span className="field-label">申请单编号</span>
                  <div className="field-value">
                    {detail.pmaInnerNo || detail.pmaXkNo}
                  </div>
                </li>
                <li>
                  <span className="field-label">收货部门</span>
                  <div className="field-value">{detail.profitCenterName}</div>
                </li>
                <li>
                  <span className="field-label">供应商</span>
                  {self.isPurchase && (
                    <div className="field-value">
                      {detail.innerVendorName}({detail.innerVendorCode})
                    </div>
                  )}
                  {!self.isPurchase && (
                    <div className="field-value">{detail.companyName}</div>
                  )}
                </li>
                <li>
                  <span className="field-label">纳税人识别号</span>
                  <div className="field-value">{detail.vendorCreditCode}</div>
                </li>
                <li>
                  <span className="field-label">开户行</span>
                  <div className="field-value">{detail.bankName}</div>
                </li>
                <li>
                  <span className="field-label">银行账号</span>
                  <div className="field-value">{detail.bankCardNo}</div>
                </li>
                <li>
                  <span className="field-label">付款说明</span>
                  <div className="field-value">{detail.payDesc}</div>
                </li>
                <li>
                  <span className="field-label">状态</span>
                  <div className="field-value">
                    <span
                      className={
                        'u-sign ' +
                        CommonFns.getStatusClass(
                          'B02_ReceiptOrder_Status',
                          detail.status
                        )
                      }
                    >
                      {detail.statusName}
                    </span>
                  </div>
                </li>
                {/* 审批流状态 仅开启后才显示 */}
                {self.isPurchase && updateTs > 0 && workflow.isActive && (
                  <li>
                    <span className="field-label">审批环节</span>
                    <div className="field-value">
                      <WorkflowStatus
                        companyCode={companyCode}
                        id={self.id}
                        workflow={workflow}
                        detail={detail}
                      />
                    </div>
                  </li>
                )}
                {/* 审批流按钮 */}
                {self.isPurchase && updateTs > 0 && workflow.isActive && (
                  <li>
                    <span className="field-label">审批操作</span>
                    <div className="field-value">
                      <WorkflowButtons
                        companyCode={companyCode}
                        id={self.id}
                        workflow={workflow}
                        detail={detail}
                        onChange={() => {
                          self.getDetail();
                        }}
                      />
                    </div>
                  </li>
                )}

                <li>
                  <span className="field-label">币别</span>
                  <div className="field-value">{detail.currencyName}</div>
                </li>
                <li>
                  <span className="field-label">采购员</span>
                  <div className="field-value">
                    {detail.arrSelectedBuyerShow}
                  </div>
                </li>
                <li>
                  <span className="field-label">付款条件</span>
                  <div className="field-value">{detail.payWayName}</div>
                </li>
                <li>
                  <span className="field-label">支付方式</span>
                  <div className="field-value">{detail.paymentMethodName}</div>
                </li>
                <li>
                  <span className="field-label">排定付款日期</span>
                  <div className="field-value">
                    {formatDate(detail.schedulePaymentDate)}
                  </div>
                </li>
                {!isDownErp && (
                  <li>
                    <span className="field-label">付款日期</span>
                    <div className="field-value">
                      {formatDate(detail.payDate)}
                    </div>
                  </li>
                )}
              </ul>
            </div>
          </div>
          {/* <div
            className={moreSign1 ? 'm-more' : 'm-more m-more-open'}
            onClick={() => {
              handleMore(1);
            }}
          >
            {moreSign1 && '更多'}
            {!moreSign1 && '收起'}
            <i className="icon-down"></i>
          </div> */}
        </div>

        {/*账款明细 */}
        {!Util.isEmpty(detail.lineList) && (
          <div className="m-details-item">
            <div className="details-item-title">
              <label>付款明细</label>
            </div>

            <div className="details-item-content">
              {detail.lineList.map((item, index) => (
                <div className="content-line line-list-item" key={index}>
                  <div className="line-list-item-title">
                    <span>项次 {index + 1}</span>
                  </div>
                  <ul className="field-list">
                    <li>
                      <span className="field-label">来源单号</span>
                      <div className="field-value">{item.sourceXkNo}</div>
                    </li>
                    <li>
                      <span className="field-label">来源单据类型</span>
                      <div className="field-value">
                        {item.sourceType === 1 ? '对账单' : '发票'}
                      </div>
                    </li>
                    <li>
                      <span className="field-label">单据日期</span>
                      <div className="field-value">
                        {formatDate(item.sourceOrderDate)}
                      </div>
                    </li>
                    <li>
                      <span className="field-label">单据金额</span>
                      <div className="field-value">
                        {formatNumber(
                          item.sourceOrderTaxAmount,
                          decimalPlace.AMOUNT
                        )}
                      </div>
                    </li>
                    <li>
                      <span className="field-label">未税金额</span>
                      <div className="field-value">
                        {formatNumber(
                          item.sourceOrderAmount,
                          decimalPlace.AMOUNT
                        )}
                      </div>
                    </li>
                    <li>
                      <span className="field-label">税额</span>
                      <div className="field-value">
                        {formatNumber(
                          item.sourceOrderTaxAmount - item.sourceOrderAmount,
                          decimalPlace.AMOUNT
                        )}
                      </div>
                    </li>
                    <li>
                      <span className="field-label">对账周期</span>
                      <div className="field-value">
                        <span>
                          {formatDate(item.recoStartTime)}
                          {'-'}
                          {formatDate(item.recoStartTime)}
                        </span>
                      </div>
                    </li>
                    <li>
                      <span className="field-label">付款条件</span>
                      <div className="field-value">{item.payWayName}</div>
                    </li>
                    <li>
                      <span className="field-label">到期日</span>
                      <div className="field-value">
                        {formatDate(item.payExpiredDate)}
                      </div>
                    </li>
                    <li>
                      <span className="field-label">请款金额</span>
                      <div className="field-value">
                        {formatNumber(item.applyTaxAmount, decimalPlace.AMOUNT)}
                      </div>
                    </li>
                    <li>
                      <span className="field-label">排定付款金额</span>
                      <div className="field-value">
                        {formatNumber(
                          item.schedulePaymentTaxAmount,
                          decimalPlace.AMOUNT
                        )}
                      </div>
                    </li>
                  </ul>
                </div>
              ))}
            </div>
          </div>
        )}

        {/* 合计 */}
        <div className="m-details-item">
          <div className="details-item-title">
            <label>合计</label>
          </div>
          <div className="details-item-content">
            <div className="content-line">
              <ul className="field-list">
                <li>
                  <span className="field-label">发票合计</span>
                  <div className="field-value">
                    <span className="blue">
                      {formatNumber(detail.amount, decimalPlace.AMOUNT)}
                    </span>
                  </div>
                </li>
                <li>
                  <span className="field-label">税额合计</span>
                  <div className="field-value">
                    <span className="blue">
                      {formatNumber(detail.tax, decimalPlace.AMOUNT)}
                    </span>
                  </div>
                </li>
                <li>
                  <span className="field-label">合计金额</span>
                  <div className="field-value">
                    <span className="blue">
                      {formatNumber(detail.taxAmount, decimalPlace.AMOUNT)}
                    </span>
                  </div>
                </li>
                <li>
                  <span className="field-label">付款申请合计</span>
                  <div className="field-value">
                    <span className="blue">
                      {formatNumber(detail.apply, decimalPlace.AMOUNT)}
                    </span>
                  </div>
                </li>
                <li>
                  <span className="field-label">排定付款合计</span>
                  <div className="field-value">
                    <span className="blue">
                      {formatNumber(detail.schedule, decimalPlace.AMOUNT)}
                    </span>
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
      {self.isPurchase && (
        <div className="wrap m-flex-box fixed-bottom">
          {User.checkAuth('10040606') &&
            [1].includes(detail.status) &&
            workflow.data &&
            workflow.data['payment_apply_audit'].complete && (
              <Button
                type="default"
                onClick={() => {
                  confirmPaymentApply();
                }}
                className="m-flex-item u-btn u-btn_primary"
              >
                确认
              </Button>
            )}
        </div>
      )}

      <Modal></Modal>
      {
        // 附件查看
        Array.isArray(fileList) && fileList.length > 0 && (
          <Download fileList={fileList} />
        )
      }
    </div>
  );
}

PaymentApplyDetail.propTypes = {
  data: PropTypes.object.isRequired,
  actions: PropTypes.object.isRequired
};

const mapStateToProps = state => {
  return {
    data: state.login
  };
};

const mapDispatchToProps = dispatch => {
  return {
    actions: bindActionCreators(MobileActions, dispatch)
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(PaymentApplyDetail);
